import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { NgxEchartsModule } from 'ngx-echarts';
import { CalvinEMRSharedModule } from './app/calvin-emr-shared/calvin-emr-shared.module';
import { LoginRoutingModule } from './app/login/login-routing.module';
import { PatientsRoutingModule } from './app/patients/patients-routing.module';
import { StudentsRoutingModule } from './app/students/students-routing.module';
import { MedicationsRoutingModule } from './app/medications/medications-routing.module';
import { SettingsRoutingModule } from './app/settings/settings-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { appRoutes, AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { authReducer } from 'src/app/calvin-emr-shared/state/auth/auth.reducer';
import { adminReducer } from 'src/app/calvin-emr-shared/state/admin/admin.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from 'src/app/state/auth/auth.effects';
import { AdminEffects } from 'src/app/calvin-emr-shared/state/admin/admin.effects';
import { AppComponent } from './app/app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import Material from '@primeng/themes/material';
import Lara from '@primeng/themes/lara';
import { definePreset } from '@primeng/themes';
import { provideRouter, withComponentInputBinding } from '@angular/router';

if (environment.production) {
  enableProdMode();
}

// see https://primeng.org/theming
const calvinEmrPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
  components: {
    menubar: {
      colorScheme: {
        light: {
          root: {
            background: '{blue.100}'
          }
        }
      }
    },
    splitbutton: {
      colorScheme: {
        light: {
          root: {
            background: '{blue.100}'
          }
        }
      }
    }
  }
})


bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      // Firebase
      AngularFireModule.initializeApp(environment.firebaseConfig), // Initialize firebase
      AngularFirestoreModule, // imports firebase/firestore, only needed for database features
      AngularFireAuthModule, // imports firebase/auth, only needed for auth features

      // Patient Libraries
      NgxEchartsModule.forRoot({ echarts: () => import('echarts'), }),

      // Application modules
      CalvinEMRSharedModule,
      LoginRoutingModule,
      PatientsRoutingModule,
      StudentsRoutingModule,
      MedicationsRoutingModule,
      SettingsRoutingModule,

      // Angular
      BrowserModule, // AppRoutingModule,

      // HttpClientModule,
      FormsModule,
      ReactiveFormsModule,
      StoreModule.forRoot({ auth: authReducer, admin: adminReducer }),
      EffectsModule.forRoot([AuthEffects, AdminEffects]),
    ),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        // preset: Lara
        preset: calvinEmrPreset,
      }
    })
  ]
})
  .catch((err) => console.error(err));
